<template>
  <v-container class="grey-lighten-3 full-height" style="overflow-x: auto;">
    <v-row justify="center">
      <v-col cols="12">
        <v-sheet class="report-paper pa-6" style="width: fit-content;" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="costingData?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + costingData?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="costingData?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${costingData?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <!-- Company Header (no header image) -->
                  <tr v-if="!costingData?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ costingData?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ costingData?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ costingData?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ costingData?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${costingData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- Report Title -->
                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">Import Costing</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Summary Info Table -->
                  <tr>
                    <td colspan="100%" class="details-table">
                      <table class="dep-table mt-5" style="">
                        <tbody>
                          <tr>
                            <td class="text-left text-bold">Code</td>
                            <td class="text-left">{{ costingData?.code }}</td>
                             <td class="text-left text-bold">LC No.</td>
                            <td class="text-left">{{ costingData?.lc_master?.lc_no }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">LC Value ({{ costingData?.currency?.code }})</td>
                            <td class="text-left">{{ costingData?.lc_value }}</td>
                            <td class="text-left text-bold">LC Value (BDT)</td>
                            <td class="text-left">{{ costingData?.lc_value_bdt }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">LC Issue Charge</td>
                            <td class="text-left">{{ costingData?.lc_issue_charge }}</td>
                            <td class="text-left text-bold">Freight Charge</td>
                            <td class="text-left">{{ costingData?.freight_charge }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">Insurance</td>
                            <td class="text-left">{{ costingData?.insurance }}</td>
                            <td class="text-left text-bold">Transportation</td>
                            <td class="text-left">{{ costingData?.transportation_cost }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">C &amp; F Expenses</td>
                            <td class="text-left">{{ costingData?.c_and_f_expanse }}</td>
                            <td class="text-left text-bold">Customs Duty</td>
                            <td class="text-left">{{ costingData?.customs_duty }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">Global Taxes</td>
                            <td class="text-left">{{ costingData?.global_taxes }}</td>
                            <td class="text-left text-bold">Total Other Expense</td>
                            <td class="text-left">{{ costingData?.total_other_expanse }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">Total Expenses</td>
                            <td class="text-left">{{ costingData?.total_expanse }}</td>
                            <td class="text-left text-bold">Overhead Cost</td>
                            <td class="text-left">{{ costingData?.overhead_cost }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">AIT (%)</td>
                            <td class="text-left">{{ costingData?.ait_percent }}</td>
                            <td class="text-left text-bold">VAT (%)</td>
                            <td class="text-left">{{ costingData?.vat_percent }}</td>
                          </tr>
                          <tr>
                            <td class="text-left text-bold">Pofit (%)</td>
                            <td class="text-left">{{ costingData?.profit_percent }}</td>
                            <td class="text-right text-bold"></td>
                            <td class="text-right"></td>
                          </tr>
                          <tr>
                            
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Details Table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table mt-5" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Sl</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Item Name</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Product Code</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">HS Code</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Qty (Kgs)</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Rate/Kg (PI) {{ costingData?.currency?.code }}</th>

                            <th colspan="2" style="border:1px solid #000; padding:4px;">
                              {{ costingData?.currency?.code }} 1 = {{ Number(costingData?.conversion_rate || 0).toFixed(2) }} TK
                            </th>

                            <th rowspan="3" style="border:1px solid #000; padding:4px;">LC Issue Charge</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Freight Charge</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Customs Duty</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Global Taxes</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Insurance</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Transportation</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">C &amp; F Cost</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Total Landing Cost</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Landed Cost / Kg</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Overhead Cost %</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Overhead Cost / Kg</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Product Cost / Kg</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Profit / Kg</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Sales Price</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">AIT / Kg</th>
                            <th rowspan="3" style="border:1px solid #000; padding:4px;">Price With AIT</th>
                            <th colspan="2" style="border:1px solid #000; padding:4px;">VAT 15%</th>
                          </tr>
                          <tr>
                            <th rowspan="2" style="border:1px solid #000; padding:4px;">Total Items Value ({{ costingData?.currency?.code }})</th>
                            <th rowspan="2" style="border:1px solid #000; padding:4px;">Value in TK</th>
                            <th rowspan="2" style="border:1px solid #000; padding:4px;">VAT / Kg</th>
                            <th rowspan="2" style="border:1px solid #000; padding:4px;">With VAT</th>
                          </tr>
                          <tr>
                            <!-- Empty 3rd row for rowspan alignment -->
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(detail, index) in costingData?.details" :key="detail.id">
                            <td style="border:1px solid #000; padding:4px; text-align:center;">{{ index + 1 }}</td>
                            <td style="border:1px solid #000; padding:4px;">{{ detail?.product?.name }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:center;">{{ detail?.product?.code }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:center;">{{ detail?.hs_code }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.qty).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.rate).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.total_value).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.value_in_tk).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.lc_issue_charge).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.freight_charge).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.custom_duty).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.global_taxes).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.insurance).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.transportation_cost).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.c_and_f_expense).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ totalLandingCost(detail).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.landed_cost_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(costingData?.overhead_cost || 0).toFixed(2) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.overhead_cost_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.product_cost_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.profit_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.sales_price).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.ait_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.price_with_ait).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.vat_per_kg).toFixed(4) }}</td>
                            <td style="border:1px solid #000; padding:4px; text-align:right;">{{ Number(detail.with_vat).toFixed(4) }}</td>
                          </tr>
                        </tbody>

                        <tfoot>
                          <tr>
                            <th colspan="3" style="border:1px solid #000; padding:4px; text-align:left;">Total</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.qty.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px;"></th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.total_value.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.value_in_tk.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.lc_issue_charge.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.freight_charge.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.custom_duty.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.global_taxes.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.insurance.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.transportation_cost.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.c_and_f_expense.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.total_landing_cost.toFixed(2) }}</th>
                            <th style="border:1px solid #000; padding:4px;"></th>
                            <th style="border:1px solid #000; padding:4px;"></th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.overhead_cost_per_kg.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.product_cost_per_kg.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.profit_per_kg.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.sales_price.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.ait_per_kg.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.price_with_ait.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.vat_per_kg.toFixed(4) }}</th>
                            <th style="border:1px solid #000; padding:4px; text-align:right;">{{ grandTotals.with_vat.toFixed(4) }}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>

                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%; height:100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer"></div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Buttons -->
    <v-row justify="end" class="d-print-none mt-4">
      <v-col cols="12" style="display:flex; justify-content: center;">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const route = useRoute();
const store = useStore();

const id = route.params.id;
const costingData = ref(null);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const totalLandingCost = (detail) => {
  return (
    Number(detail.value_in_tk || 0) +
    Number(detail.lc_issue_charge || 0) +
    Number(detail.freight_charge || 0) +
    Number(detail.custom_duty || 0) +
    Number(detail.global_taxes || 0) +
    Number(detail.insurance || 0) +
    Number(detail.transportation_cost || 0) +
    Number(detail.c_and_f_expense || 0)
  );
};

const grandTotals = computed(() => {
  const details = costingData.value?.details || [];
  const sum = (key) => details.reduce((acc, item) => acc + Number(item[key] || 0), 0);

  return {
    qty: sum("qty"),
    total_value: sum("total_value"),
    value_in_tk: sum("value_in_tk"),
    lc_issue_charge: sum("lc_issue_charge"),
    freight_charge: sum("freight_charge"),
    custom_duty: sum("custom_duty"),
    global_taxes: sum("global_taxes"),
    insurance: sum("insurance"),
    transportation_cost: sum("transportation_cost"),
    c_and_f_expense: sum("c_and_f_expense"),
    total_landing_cost: details.reduce((acc, d) => acc + totalLandingCost(d), 0),
    overhead_cost_per_kg: sum("overhead_cost_per_kg"),
    product_cost_per_kg: sum("product_cost_per_kg"),
    profit_per_kg: sum("profit_per_kg"),
    sales_price: sum("sales_price"),
    ait_per_kg: sum("ait_per_kg"),
    price_with_ait: sum("price_with_ait"),
    vat_per_kg: sum("vat_per_kg"),
    with_vat: sum("with_vat"),
  };
});

const print = (isPad) => {
  invoiceHeader.value = isPad === 1;
  pagePadding.value   = isPad === 1 ? 0 : 100;

  setTimeout(() => {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow  = window.open("", "_blank", `width=${screen.width},height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Import Costing</title>
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
          * { margin:0; padding:0; box-sizing:border-box; }
          .text-bold{ font-weight: bold; }
          @page { 
            size: landscape;
            margin:${pagePadding.value}px 0;
            
          }
          html, body { margin:0; padding:0; width:100%; height:auto; }
          body { font-family:sans-serif; background:#fff; color:#000; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
          .report-paper { width:100%; padding:0 !important; background:#fff; margin:0; }
          .invoice-container { width:100%; margin:0; padding:0; }
          .invoice-content { width:100%; margin:0; padding:0; overflow:visible; }
          header img { width:100%; display:block; margin:0; padding:0; }
          .details-table { padding:0px 25px; }
          table { width:100%; margin:0; padding:0; }
          footer { position:fixed; bottom:0; left:0; right:0; width:100%; z-index:10; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
          footer img { width:100%; display:block; margin:0; padding:0; }
          .page-header { margin-bottom:20px; padding:20px 0; }
          .header-section { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #eee; padding-bottom:10px; margin-bottom:16px; }
          .company-name { font-size:9px; font-weight:bold; text-transform:uppercase; margin:0 0 4px 0; }
          .company-text { font-size:9px; margin:2px 0; display:flex; align-items:center; }
          .logo-container img { max-height:70px; max-width:150px; }
          .report-title { font-size:16px; text-align:center; margin:8px 0; }
          .watermark { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); z-index:0; }
          table { width:100% !important; border-collapse:collapse; font-size:9px; margin:8px 0; background:white; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
          th, td { border:none; padding:0; vertical-align:middle; }
          th { background:#e0e0e0; text-align:center; font-weight:bold; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
          .text-center { text-align:center; }
          .text-right { text-align:right; }
          .text-left { text-align:left; }
          .text-right { text-align:right; }
          table { page-break-inside:avoid; orphans:3; widows:3; }
          tr { page-break-inside:avoid; }
          .mt-5 { margin-top:5px !important; }
          .my-6 { margin-top:0px !important; margin-bottom:0px !important; }
          img { max-width:100% !important; height:auto !important; }
          .d-flex { display:flex; }
          .justify-space-between { justify-content:space-between; }
          .align-start { align-items:flex-start; }
          .pa-6 { padding:0 !important; }
          .invoice-footer { margin-top:auto; position:fixed; left:0; bottom:15px; width:100%; }
          .company-info { flex:1; }
          @media print {
            body { margin:0; padding:0; }
            .report-paper { margin:0; padding:0; }
            main { padding:180px 20px 150px; }
            .watermark { position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); z-index:0; }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 500);
    invoiceHeader.value = true;
    pagePadding.value   = 0;
  }, 500);
};

onMounted(async () => {
  try {
    store.commit("SET_LOADING", { color: "primary" });
    const res = await store.dispatch("lcImportLcCosting/getLcImportLcCostingById", id);
    store.commit("UNSET_LOADING");

    if (res?.data?.success) {
      costingData.value = res.data.data;
    } else {
      console.error("API returned unsuccessful response:", res);
    }
  } catch (error) {
    console.error("Error fetching costing data:", error);
    store.commit("UNSET_LOADING");
  }
});
</script>

<style scoped>
.text-bold{ font-weight: bold; }
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white;}
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 4px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 0; }
.d-print-none { display: block !important; }
@media print {
  .d-print-none { display: none !important; }
}
</style>